module.exports = __webpack_public_path__ + "img/29.4fb6439d.gif";